import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography} from '@material-ui/core';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import OtpVerification from './OtpVerification';
import SetNewPassword from './SetNewPassword';
import SignUp from './Signup';
import SignupVerification from './SignupVerification';
import WebnyayLogo from "images/web.svg";
import TdsatLogoWhite from "images/TDSAT_white_logo.png";

const LoginTdsatFlow = () => {
  const [currentStep, setCurrentStep] = useState('login');
  const [otpVerificationValues, setOtpVerificationValues] = useState({})

  const handleSetOtpValues = (values) => {
    setOtpVerificationValues(values);
  };

  const renderStep = () => {
    switch (currentStep) {
      case 'login':
        return <Login setCurrentStep={setCurrentStep} />;
      case 'forgotPassword':
        return <ForgotPassword setCurrentStep={setCurrentStep} />;
      case 'otpVerification':
        return <OtpVerification setCurrentStep={setCurrentStep} />;
      case 'setNewPassword':
        return <SetNewPassword setCurrentStep={setCurrentStep} />;
      case 'signUp':
        return <SignUp setCurrentStep={setCurrentStep} setOtpVerificationValues={handleSetOtpValues}/>;
      case 'signUpVerification':
        return <SignupVerification setCurrentStep={setCurrentStep}  otpVerificationValues={otpVerificationValues}/>;
      default:
        return <Login setCurrentStep={setCurrentStep} />;
    }
  };

  return (
    <Box display="flex"  flexDirection={{ xs: 'column', sm: 'row' }}>
      {/* <Box width={{ xs: 'none', sm: '50%' }} bgcolor="#4A3BFF" height={{ xs: 'auto' }} display={'flex'} justifyContent={'space-between'} flexDirection={'column'}>
        <Grid style={{display: 'flex', alignItems: 'center'}}>
          <div style={{ width: 175, padding: '1rem 1rem 0 1rem'}}>
            <img src={TdsatLogoWhite} alt="TDSAT Logo"  width={'100%'}/>
          </div>
          <Typography style={{ fontSize: '1.5rem', fontFamily: 'Satoshi-Bold', color: '#fff', lineHeight: 'normal' }}>
            Telecom Disputes Settlement & Appellate Tribunal (TDSAT)
        </Typography>
        </Grid>
      <Grid style={{ padding: '1rem 3rem 3rem 3rem' }}>
        <Typography style={{ fontSize: '2.5rem', fontFamily: 'Satoshi-Bold', color: '#fff', lineHeight: 'normal' }}>
          E-Filing Portal
        </Typography>
      </Grid>
        <Grid style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding:'1rem 1.5rem'}}>
          <Typography style={{fontSize: '1rem', color: '#fff' }}>Designed & Developed by:</Typography>
          <img src={WebnyayLogo} alt="Webnyay Logo" style={{ width: 120 }} />
        </Grid>
      </Box> */}
      <Box width={{ xs: '100%', sm: '100%' }} height={{ xs: 'auto' }}  display="flex" justifyContent={currentStep === 'signUp' ? 'flex-start' : 'center'} alignItems="center" flexDirection="column" p={3}  overflow='auto'>
        {renderStep()}
      </Box>
    </Box>
  );
};

export default LoginTdsatFlow;
